import { h } from '@stencil/core';
import { EQdsButtonImportance, EQdsButtonSize } from '@pes-ui/utils';
import { MAX_VISIBLE_CARDS_WHILE_COLLAPSED } from '../constants';
export const ViewMore = ({ hiddenElementsCount, rangeBlockCollapsed, viewMoreLabel, viewLessLabel, toggleRangeBlock, allCardsRenderers, }) => {
  if (allCardsRenderers.length <= MAX_VISIBLE_CARDS_WHILE_COLLAPSED)
    return null;
  const text = rangeBlockCollapsed
    ? viewMoreLabel.replace('#number of values hidden#', hiddenElementsCount.toString())
    : viewLessLabel;
  return (h("div", { class: "subcategory-block__collapser-wrapper" }, h("qds-button", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED, onClick: toggleRangeBlock, action: !rangeBlockCollapsed ? 'dropdown-close' : 'dropdown', text: text })));
};
